<template>
  <mp-box>
    <mp-box data-qa="review-cycle-component-btn-create-cycle-wrapper" @click="createCycle">
      <slot><mp-button>Create new cycle</mp-button></slot>
    </mp-box>
    <modal-cycle-purpose ref="modalCyclePurpose" :is-first="isFirstRun" />
    <modal-warn-quota title="Create new cycle" is-restricted :is-open.sync="isModalExceed" />
  </mp-box>
</template>
<script>
import ModalCyclePurpose from '@/views/reviews/cycle/components/ModalCyclePurpose';
import ModalWarnQuota from '@/views/settings/manage-user/component/ModalWarnQuota';

export default {
  name: 'ButtonCreateCycle',
  components: {
    ModalCyclePurpose,
    ModalWarnQuota,
  },
  props: {
    isFirstRun: {
      type: Boolean,
      default: false,
    },
    isDisabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      isModalExceed: false,
    };
  },
  computed: {
    isQuotaRestricted() {
      return this.$store.getters.getGrantAccess?.isQuotaRestricted;
    },
  },
  methods: {
    createCycle() {
      if (!this.isDisabled) {
        if (this.isQuotaRestricted) this.isModalExceed = true;
        else this.$refs.modalCyclePurpose.handleOpen();
      }
    },
  },
};
</script>
